var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TopParallax',{attrs:{"title":"Daily Community Program in Luanda","img-src":_vm.imgSrc}}),_c('ChildrenBar'),_c('LuandaContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }